export const getCirclePostIdForPoll = post => {
  const postId =
    post?.id ?? post?.post?.id ?? post?.data?.id ?? post?.record?.id ?? post?.post_id ?? null;
  return postId === undefined || postId === null || postId === '' ? null : String(postId);
};

export const extractCirclePostIdsForPolls = posts =>
  Array.from(
    new Set((Array.isArray(posts) ? posts : []).map(getCirclePostIdForPoll).filter(Boolean))
  );

export const mergePollsIntoPosts = (posts, pollsByCirclePostId = {}) =>
  (Array.isArray(posts) ? posts : []).map(post => {
    const circlePostId = getCirclePostIdForPoll(post);
    if (!circlePostId) return post;

    if (Object.prototype.hasOwnProperty.call(pollsByCirclePostId, circlePostId)) {
      return {
        ...post,
        poll: pollsByCirclePostId[circlePostId] || null,
        pollHydrationError: null,
      };
    }

    return post;
  });

export const markPostsWithPollHydrationError = posts =>
  (Array.isArray(posts) ? posts : []).map(post =>
    post?.poll
      ? {
          ...post,
          pollHydrationError: true,
        }
      : post
  );

export const replacePollInPosts = (records = [], circlePostId, poll) =>
  (Array.isArray(records) ? records : []).map(record =>
    getCirclePostIdForPoll(record) === String(circlePostId)
      ? {
          ...record,
          poll,
          pollHydrationError: null,
        }
      : record
  );
